'use client';

import { useNuqsNextPagesRouterAdapter } from '../../chunk-F6S36SYV.js';
import '../../chunk-TUUFGL5M.js';
import '../../chunk-3RCMAOX7.js';
import { createAdapterProvider } from '../../chunk-OMREKXUP.js';

// src/adapters/next/pages.ts
var NuqsAdapter = createAdapterProvider(useNuqsNextPagesRouterAdapter);

export { NuqsAdapter };
